import { createReducer, createAction } from '@reduxjs/toolkit';
import { LocationData } from 'lib/location/Geolocate';
import { LocationSlice } from 'types/State';

export type Location = LocationData & Record<string, unknown>;

export const setGeolocationData = createAction<Location>('session/setGeolocationData');

const initialState: LocationSlice = null;

export const geolocationReducer = createReducer<LocationSlice>(initialState, {
  [setGeolocationData.type]: (state: LocationSlice, action) => {
    return action.payload;
  },
});
